import { Component, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-call-events',
  templateUrl: './call-events.component.html',
  styleUrls: ['./call-events.component.scss']
})
export class CallEventsComponent implements OnInit {
  rsltType: string = "call-events";

  title: string;
  staticScreen = false;
  @Output() childTitleEvent = new EventEmitter();

  constructor() {  }

  ngOnInit() { }

  ////Called from App Component
  //refreshClicked() {
  //  console.log('called')
  //}
  parentEvent(title) {
    this.title = title;
    this.childTitleEvent.emit({ title: this.title, staticScreen: this.staticScreen });
  }
}
